<div class="flex flex-col w-9/12 mx-auto my-20 3xl:w-8/12 gap-28 2lg:gap-0" *ngIf="gallery$ | async as images">
  <div class="flex flex-col 2lg:flex-row">
    <div class="flex flex-col justify-center w-full gap-8 2lg:w-1/2">
      <h1 class="font-extrabold text-7xl xl:text-9xl text-base-font-primary">
        {{ 'student-focus.title' | translate }}
      </h1>
      <div class="text-2xl font-normal text-base-blue" [innerHtml]="'student-focus.description' | translate"></div>
    </div>
    <div class="w-full 2lg:w-1/2">
      <img
        loading="lazy"
        [src]="images[gallery.FocoAluno]"
        [alt]="'student-focus.title' | translate"
        class="w-10/12 max-w-full mx-auto md:w-1/2 2lg:w-auto"
      />
    </div>
  </div>
  <div class="flex flex-col-reverse 2lg:flex-row">
    <div class="w-full 2lg:w-1/2">
      <img
        loading="lazy"
        [src]="images[gallery.TecnologiaEducacional]"
        [alt]="'educational-technologies.title' | translate"
        class="w-10/12 max-w-full mx-auto md:w-1/2 2lg:w-auto"
      />
    </div>
    <div class="flex flex-col justify-center w-full gap-8 2lg:w-1/2">
      <h1 class="font-extrabold text-7xl xl:text-9xl text-base-font-primary">
        {{ 'educational-technologies.title' | translate }}
      </h1>
      <div
        class="text-2xl font-normal text-base-blue"
        [innerHtml]="'educational-technologies.description' | translate"
      ></div>
    </div>
  </div>
  <div class="flex flex-col 2lg:flex-row">
    <div class="flex flex-col justify-center w-full gap-8 2lg:w-1/2">
      <h1 class="font-extrabold text-7xl xl:text-9xl text-base-font-primary">
        {{ 'teaching-system.title' | translate }}
      </h1>
      <div class="text-2xl font-normal text-base-blue" [innerHtml]="'teaching-system.description' | translate"></div>
    </div>
    <div class="w-full 2lg:w-1/2">
      <img
        loading="lazy"
        [src]="images[gallery.SistemaEnsino]"
        [alt]="'teaching-system.description' | translate"
        class="w-10/12 max-w-full mx-auto md:w-1/2 2lg:w-auto"
      />
    </div>
  </div>
</div>
